module.exports = __webpack_public_path__ + "img/selected5-min.48b1ca58.png";